import {
  PLAN_FEATURES,
  PLAN_LIMITS,
  PLAN_NAMES,
  PLAN_ORDER
} from './planCatalog.js';

export {PLAN_FEATURES, PLAN_LIMITS, PLAN_NAMES, PLAN_ORDER};

export function normalizePlanType(planType) {
  return PLAN_LIMITS[planType] ? planType : 'solo';
}

export function getPlanLimit(planType) {
  return PLAN_LIMITS[normalizePlanType(planType)];
}

export function getPlanName(planType) {
  return PLAN_NAMES[normalizePlanType(planType)];
}

export function getNextPlanType(planType) {
  const currentPlan = normalizePlanType(planType);
  const currentIndex = PLAN_ORDER.indexOf(currentPlan);

  return PLAN_ORDER[currentIndex + 1] || null;
}

export function getNextPlanName(planType) {
  const nextPlan = getNextPlanType(planType);
  return nextPlan ? getPlanName(nextPlan) : null;
}

export function hasPlanFeature(planType, feature) {
  return (PLAN_FEATURES[feature] || []).includes(normalizePlanType(planType));
}
